// Static package data for the SEO pricing pages (Phase 1).
// Structured so it can later be backed by a database without rebuilding the pages.
// No invented prices — every package uses "Request a Quote".

export const STANDARD_PACKAGES = [
  {
    key: "basic",
    name: "Basic",
    blurb: "A focused foundation for businesses beginning their search journey.",
    features: [
      "Keyword research (core set)",
      "On-page SEO essentials",
      "Technical SEO health check",
      "Content optimisation guidance",
      "Monthly reporting",
      "Email support",
    ],
    highlight: false,
  },
  {
    key: "silver",
    name: "Silver",
    blurb: "Steady growth with broader coverage across on-page and technical SEO.",
    features: [
      "Expanded keyword research",
      "On-page SEO (priority pages)",
      "Technical SEO fixes",
      "Content optimisation (ongoing)",
      "Local SEO foundations",
      "Monthly reporting",
      "Priority email support",
    ],
    highlight: false,
  },
  {
    key: "gold",
    name: "Gold",
    blurb: "A complete growth engine combining content, authority and local reach.",
    features: [
      "Comprehensive keyword research",
      "Full on-page SEO",
      "Advanced technical SEO",
      "Content optimisation + strategy",
      "Off-page SEO & link acquisition",
      "Local SEO (multi-location ready)",
      "Bi-weekly reporting",
      "Dedicated support",
    ],
    highlight: true,
  },
  {
    key: "premium",
    name: "Premium",
    blurb: "Our most comprehensive standard package for competitive markets.",
    features: [
      "Enterprise-grade keyword research",
      "Full on-page + technical SEO",
      "Content strategy & production support",
      "Authority link acquisition",
      "Local & regional SEO",
      "Conversion-focused recommendations",
      "Weekly reporting",
      "Priority support + strategy calls",
    ],
    highlight: false,
  },
];

export const STANDARD_FEATURES = [
  "Keyword research",
  "On-page SEO",
  "Technical SEO",
  "Content optimisation",
  "Off-page SEO",
  "Link acquisition",
  "Local SEO",
  "Reporting & support",
];

// Row = feature, then availability per package [basic, silver, gold, premium]
export const STANDARD_MATRIX = [
  ["Keyword research", ["Core", "Expanded", "Comprehensive", "Enterprise"]],
  ["On-page SEO", ["Essentials", "Priority pages", "Full", "Full + CRO"]],
  ["Technical SEO", ["Health check", "Fixes", "Advanced", "Advanced"]],
  ["Content optimisation", ["Guidance", "Ongoing", "Strategy-led", "Strategy + production"]],
  ["Off-page SEO", [false, false, true, true]],
  ["Link acquisition", [false, false, true, "Authority"]],
  ["Local SEO", [false, "Foundations", "Multi-location", "Local + regional"]],
  ["Reporting & support", ["Monthly · email", "Monthly · priority", "Bi-weekly · dedicated", "Weekly · priority"]],
];

export const ELITE_PACKAGES = [
  {
    key: "professional",
    name: "Professional",
    blurb: "Enterprise-grade search for organisations scaling into competitive markets.",
    features: [
      "Advanced technical SEO",
      "Content strategy & roadmap",
      "Competitor analysis",
      "Authority development",
      "Advanced reporting & dashboards",
    ],
    highlight: false,
  },
  {
    key: "corporate",
    name: "Corporate",
    blurb: "Multi-market search leadership with AI-era visibility built in.",
    features: [
      "Everything in Professional",
      "International SEO",
      "Ecommerce SEO",
      "AI visibility (GEO / AEO)",
      "Digital PR & authority growth",
      "Quarterly strategy workshops",
    ],
    highlight: true,
  },
  {
    key: "enterprise",
    name: "Enterprise",
    blurb: "A dedicated search program for category leaders and global brands.",
    features: [
      "Everything in Corporate",
      "Global international SEO",
      "Full-funnel content operations",
      "AI visibility & answer-engine optimisation",
      "Executive reporting & governance",
      "Dedicated senior team",
    ],
    highlight: false,
  },
];

export const ELITE_FEATURES = [
  "Advanced technical SEO",
  "Content strategy",
  "Competitor analysis",
  "International SEO",
  "Ecommerce SEO",
  "Authority development",
  "AI visibility (GEO / AEO)",
  "Advanced reporting",
];
